export default __webpack_public_path__ + "911fe63bee4d6f0b76331a8231e065e8.png";